import React from 'react';
import {
  GuestMobileAppCrossSellContainer,
  GuestMobileAppText,
  IPhoneWrapper,
  StyledMobileClip,
  StyledAppCTALink,
  StyledIphoneImage,
  StyledWrapper,
  StyledMobileAppColumnContainer,
} from './GuestMobileAppCrossSell.styles';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { Box } from '@components/Box';
import { VimeoVideo } from '@components/VimeoVideo';
import { useTranslation } from 'react-i18next';

const urls = {
  photoCollectionVideoURL: 'sitewide/cross-sell_mobile/photo-collection_video.mp4',
  scheduleVideoURL: 'sitewide/cross-sell_mobile/schedule_video.mp4',
  travelVideoURL: 'sitewide/cross-sell_mobile/travel_video.mp4',
  phoneImagePath: 'common/phone-frames/iphone_yellow1.svg',
  phoneSVGMaskPath: 'common/phone-frames/iphone_screen_mask.svg',
} as const;

export const GuestMobileAppCrossSell: React.FC = () => {
  const { t } = useTranslation();
  const guestMobileAppSectionData = t('sections.guestMobileApp', { ns: 'weddingWebsitePage' });

  return (
    <Box backgroundColor={'white'} paddingY={[12, 0]} id="Mobile_Cross">
      <GuestMobileAppCrossSellContainer>
        <StyledMobileAppColumnContainer width={'seven'}>
          <IPhoneWrapper>
            <StyledIphoneImage alt="iphone frame" src={urls.phoneImagePath} optimization="default" />
            <StyledWrapper>
              <LazyLoadWrapper>
                <StyledMobileClip>
                  <VimeoVideo
                    title={guestMobileAppSectionData.videoTitle}
                    embedUrl={guestMobileAppSectionData.videoUrl}
                    posterUrl={guestMobileAppSectionData.videoPosterUrl}
                    alt={guestMobileAppSectionData.videoTitle}
                    background
                    loop
                  />
                </StyledMobileClip>
              </LazyLoadWrapper>
            </StyledWrapper>
          </IPhoneWrapper>
        </StyledMobileAppColumnContainer>
        <StyledMobileAppColumnContainer width={'five'}>
          <GuestMobileAppText
            textAlign="left"
            eyebrowVariant="sectionEyeBrow24"
            eyebrow={t('eyebrowText', { ns: 'guestMobileAppCrossSell' })}
            eyebrowTagName="h2"
            eyebrowColor="humana5"
            title={t('titleText', { ns: 'guestMobileAppCrossSell' })}
            titleVariant="hed56"
            titleColor="neutra6"
            titleTagName="h2"
            body={t('bodyText', { ns: 'guestMobileAppCrossSell' })}
            bodyVariant="dek20"
            bodyColor="neutra5"
            bodyMaxWidth="350px"
          />
          <StyledAppCTALink id={'weddingWebsiteGuestMobileAppCrossSellCTA'} aria-label="Mobile App" href="/app" hasChevron>
            {t('ctaText', { ns: 'guestMobileAppCrossSell' })}
          </StyledAppCTALink>
        </StyledMobileAppColumnContainer>
      </GuestMobileAppCrossSellContainer>
    </Box>
  );
};
